import { render, staticRenderFns } from "./theme.vue?vue&type=template&id=1dab2a26&scoped=true"
import script from "./theme.vue?vue&type=script&lang=js"
export * from "./theme.vue?vue&type=script&lang=js"
import style0 from "./theme.vue?vue&type=style&index=0&id=1dab2a26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dab2a26",
  null
  
)

export default component.exports